import React, { useEffect, useState } from "react";
import { Background, Button, Container, Hr, Row, DivTable, Titulo } from "./style";
import { IoPencilOutline, IoTrashOutline } from "react-icons/io5";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import ModalRegisterAvisos from "../../../components/Modal/Dev/Avisos/index.js";
import ModalEditarAvisos from "../../../components/Modal/Dev/Avisos/index.js";

function AvisosDev() {
  const [avisos, setAvisos] = useState([]);
  const [aviso, setAviso] = useState({});
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [showModalRegister, setShowModalRegister] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);

  useEffect(() => {
    api
      .get(`/avisos?dev=${true}`)
      .then((response) => {
        setAvisos(response.data);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    setTotalPages(Math.ceil(avisos.length / 15));
  }, [avisos]);

  async function handleDelete(id) {
    Swal.fire({
      title: "Você tem certeza?",
      text: "O aviso será excluído permanentemente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Excluir",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await api.delete(`/dev/avisos/${id}`);
        if (response.data.error) {
          return Swal.fire({
            title: "Exclusão não permitida!",
            text: response.data.error,
            icon: "warning",
            confirmButtonColor: "var(--blue-color)",
          });
        }
        Toast.fire({
          icon: "success",
          title: "Excluído com sucesso!",
        });
        setAvisos(avisos.filter((aviso) => aviso.id !== id));
      }
    });
  }

  return (
    <Background>
      <Container>
        <Titulo>Controle de Usuários</Titulo>
        <Hr />
        <Row>
          <Button
            onClick={() => {
              setShowModalRegister(true);
            }}
          >
            Novo
          </Button>
        </Row>
        <DivTable>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Descrição</th>
                <th>Perfis</th>
                <th>Vencimento</th>
                <th>Editar</th>
                <th>Excluir</th>
              </tr>
            </thead>
            <tbody>
              {avisos?.length > 0 &&
                avisos?.slice((page - 1) * 15, page * 15)?.map((a, i) => (
                  <tr key={i}>
                    <td data-title="ID" className="">
                      {a.id}
                    </td>
                    <td data-title="Descricao" value={a.descricao} className="td-left descricao">
                      {a.descricao}
                    </td>
                    <td data-title="Tipo" value={a.tipo} className="">
                      {a.tipo?.toUpperCase() ?? "TODOS"}
                    </td>
                    <td
                      data-title="Vencimento"
                      value={new Date(a.vencimento)?.toLocaleDateString("pt-br")}
                      title={new Date(a.vencimento)?.toLocaleDateString("pt-br")}
                      className="menor"
                    >
                      {new Date(a.vencimento)?.toLocaleDateString("pt-br") ?? "N/A"}
                    </td>
                    <td data-title="Editar" className="center">
                      <IoPencilOutline
                        title="Editar"
                        style={{ fontSize: "25px", cursor: "pointer" }}
                        onClick={() => {
                          setAviso(a);
                          setShowModalEdit(true);
                        }}
                      />
                    </td>
                    <td data-title="Excluir" className="center">
                      <IoTrashOutline
                        title="Excluir"
                        style={{ fontSize: "25px", cursor: "pointer" }}
                        onClick={() => {
                          handleDelete(a.id);
                        }}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </DivTable>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
      <ModalRegisterAvisos showModal={showModalRegister} setShowModal={setShowModalRegister} />
      <ModalEditarAvisos showModal={showModalEdit} setShowModal={setShowModalEdit} dados={aviso} setDados={setAviso} />
    </Background>
  );
}

export default AvisosDev;
